import { __assign, __rest, __spreadArray } from "tslib";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useMemo, useState } from "react";
import { Chip, IconButton, Stack, TextField } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import * as yup from "yup";
import findIndex from "lodash/findIndex";
import { FieldControl, } from "@pangeacyber/react-mui-shared";
var UnControlledShareEmailsField = function (_a) {
    var _b = _a.onValueChange, onValueChange = _b === void 0 ? function () { } : _b, props = __rest(_a, ["onValueChange"]);
    var value = useMemo(function () {
        var value = props.value || props.default || [];
        var valueSet = new Set(value);
        return Array.from(valueSet);
    }, [props.value, props.default]);
    var _c = useState(""), newValue = _c[0], setNewValue = _c[1];
    var _d = useState(undefined), newValueError = _d[0], setNewValueError = _d[1];
    var validate = function () {
        yup
            .string()
            .trim()
            .email("Must be a valid email address")
            .isValid(newValue)
            .then(function (isValid) {
            if (!isValid)
                setNewValueError("Must be a valid email address");
            else
                setNewValueError(undefined);
        });
    };
    useEffect(function () {
        if (newValue === "") {
            setNewValueError(undefined);
            return;
        }
        validate();
    }, [newValue]);
    var handleAddNewValue = function () {
        if (!newValue || !!newValueError)
            return;
        var value_ = __spreadArray([], value, true);
        value_.push(newValue);
        var valueSet = new Set(value_);
        value_ = Array.from(valueSet);
        onValueChange(value_);
        setNewValue("");
    };
    var handleRemoveValue = function (email) {
        var idx = findIndex(value, function (v) { return v === email; });
        if (idx === -1)
            return;
        var value_ = value.slice(0, idx).concat(value.slice(idx + 1));
        onValueChange(value_);
    };
    return (_jsxs(Stack, { spacing: 1, width: "100%", children: [_jsxs(Stack, { width: "100%", direction: "row", alignItems: "center", spacing: 1, children: [_jsx(TextField, { value: newValue, name: "recipient_email", label: "Add email", onChange: function (e) {
                            var value = e.target.value;
                            setNewValue(value);
                            e.stopPropagation();
                        }, error: !!newValueError, helperText: newValueError, onKeyDown: function (event) { return event.stopPropagation(); }, autoComplete: "off", fullWidth: true, onKeyUp: function (event) {
                            if (event.key === "Enter") {
                                handleAddNewValue();
                                event.preventDefault();
                            }
                        }, onBlur: handleAddNewValue, size: "small" }), _jsx(IconButton, { size: "small", title: "Add email", onClick: handleAddNewValue, children: _jsx(AddIcon, { fontSize: "small" }) })] }), _jsx(Stack, { direction: "row", gap: 0.5, sx: {
                    flexWrap: "wrap",
                    minHeight: "80px",
                    overflow: "hidden",
                    overflowY: "auto",
                    maxHeight: "calc(100vh - 600px)",
                }, children: value.map(function (email, idx) {
                    return (_jsx(Chip, { label: email, onDelete: function () { return handleRemoveValue(email); } }, "email-".concat(idx, "-").concat(email)));
                }) })] }));
};
var ShareEmailsField = function (props) {
    return (_jsx(FieldControl, __assign({}, props, { children: _jsx(UnControlledShareEmailsField, __assign({}, props)) })));
};
export default ShareEmailsField;
